export default "__VITE_ASSET__BdNzCxph__"